import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Breadcrumb from '../../components/Breadcrumb';
import { useForm } from 'react-hook-form';
import { InputGroup, Form, Button, Stack } from 'react-bootstrap';
import { get, post } from '../../services/apiController';
import { errorToast, successToast } from '../../util/toast.util';

const RedeemCoupon = () => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      coupon_code: '',
      name: '',
      mobile: '',
      validationAttemped: false,
      isValidCoupon: false,
    },
  });

  const onSubmit = (data) => {
    post(data, '/cs/coupons/redeem-coupon')
      .then((res) => {
        successToast(res.message);
        reset();
      })
      .catch((err) => {
        errorToast(err.response.data.errors[0]);
      });
  };

  const validateCoupon = () => {
    if (getValues('coupon_code') === '') {
      errorToast('Please enter a coupon code');
      return;
    }

    get(`/cs/coupons/check-coupon?coupon_code=${getValues('coupon_code')}`)
      .then((res) => {
        setValue('validationAttemped', true);
        setValue('isValidCoupon', true);
      })
      .catch((err) => {
        errorToast(err.response.data.errors[0]);
      });
  };

  const validationAttemped = watch('validationAttemped');
  const couponCode = watch('coupon_code');

  useEffect(() => {
    if (couponCode) {
      setValue('validationAttemped', false);
      setValue('isValidCoupon', false);
    }
  }, [couponCode]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Coupons' },
          { link: '#', title: 'Redeem Coupon' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Redeem Coupon
          </h4>
        </div>
        <div className="card-body pt-4 pb-4">
          <div className="row">
            <div className="col-5">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <InputGroup className="mb-3">
                  <Form.Control
                    placeholder="Enter coupon code"
                    aria-label="Coupon Code"
                    aria-describedby="basic-addon2"
                    {...register('coupon_code')}
                  />
                  <Button variant="outline-secondary" onClick={validateCoupon}>
                    Validate
                  </Button>
                </InputGroup>
                {validationAttemped && (
                  <Stack gap={3} className="w-100">
                    <Stack direction="horizontal" gap={3} className="w-100">
                      <div className="w-50">
                        <label htmlFor="customerName">Customer Name</label>
                        <input type="text" className="form-control" id="customerName" {...register('name', { required: true })} />
                      </div>
                      <div className="w-50">
                        <label htmlFor="customerMobile">Customer Mobile</label>
                        <input type="text" className="form-control" id="customerMobile" {...register('mobile', { required: true })} />
                      </div>
                    </Stack>
                    <div className="mt-1">
                      <Button type="submit" className="btn btn-primary">
                        Redeem Coupon
                      </Button>
                    </div>
                  </Stack>
                )}
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default RedeemCoupon;
